import React from "react";
import ChangePageTitle from "../components/change-title-page";
import Terms_conditions_content from "../components/component-terms-conitions";

function Terms_conditions(){

    return(
        <>
            <ChangePageTitle pageTitle="قوانین و مقررات | رستوران باغبان" />
            <Terms_conditions_content />
        </>
    );

}

export default Terms_conditions;